import { useState } from "react";
import { UseRiskClientData } from "./types/use-risk-client";
import { getRiskSearchResults } from "./search-results-service";
import { SearchContextType, useSearch } from "../search/search-context";
import { RiskSearchRequest } from "./types/risk-search-request";
import { RiskSearchResult } from "./types/risk-search-response";

export const mapRequestDataToSearchParams = (
  formData: SearchContextType,
): RiskSearchRequest => {
  const hasOrganisation =
    formData.organisationName ||
    formData.organisationPostCode ||
    formData.organisationType ||
    formData.organisationHouseNumber ||
    formData.organisationGmcNumber;

  const hasVehicle = formData.registrationNumber || formData.vinNo;

  const hasAddress = formData.fullAddress || formData.pafudprn;

  const searchCriteria: RiskSearchRequest = {
    claimReference: formData.claimReference,
    incidentDate: formData.incidentDate,
    firstName: formData.firstName,
    middleNames: formData.middleNames,
    lastName: formData.lastName,
    dateOfBirth: formData.dateOfBirth,
    drivingLicenseNumber: formData.drivingLicenseNumber,
    nationalInsuranceNumber: formData.nationalInsuranceNumber,
    passportNumber: formData.passportNumber,
    emailAddress: formData.emailAddress,
    phoneNumbers: [formData.telNo, formData.mobileTelNo].filter(Boolean),
    addresses: hasAddress
      ? [
          {
            pafudprn: formData.pafudprn,
            fullAddress: formData.fullAddress,
          },
        ]
      : [],
    organisations: hasOrganisation
      ? [
          {
            organisationName: formData.organisationName,
            organisationPostCode: formData.organisationPostCode,
            organisationType: formData.organisationType,
            companiesHouseNumber: formData.organisationHouseNumber,
            gmcNumber: formData.organisationGmcNumber,
            sraNumber: "",
          },
        ]
      : [],
    vehicles: hasVehicle
      ? [
          {
            registrationNumber: formData.registrationNumber,
            vehicleIdentificationNumber: formData.vinNo,
          },
        ]
      : [],
  };

  return searchCriteria;
};

const useRiskSearchResults = (): UseRiskClientData & {
  fetchResults: () => Promise<void>;
} => {
  const form = useSearch();
  const [data, setData] = useState<RiskSearchResult | undefined>(undefined);
  const [error, setError] = useState<unknown>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchResults = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const response = await getRiskSearchResults(
        mapRequestDataToSearchParams(form),
      );
      setData(response);
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isLoading,
    error,
    fetchResults,
  };
};

export default useRiskSearchResults;
